export default __webpack_public_path__ + "static/media/README.352be8da.md";